export class StorageLocalModel<T> {
  constructor(
    private key: string,
    private isBrowser: boolean,
    private defaultValue: T = null as any,
  ) {}

  set value(val: T) {
    if (this.isBrowser) localStorage.setItem(this.key, JSON.stringify(val));
  }

  get value() {
    try {
      return this.isBrowser && localStorage.getItem(this.key)
        ? JSON.parse(localStorage.getItem(this.key) || '')
        : this.defaultValue;
    } catch (error) {
      return this.defaultValue;
    }
  }

  delete() {
    if (this.isBrowser) localStorage.removeItem(this.key);
  }

  get isHasValue() {
    if (!this.isBrowser) return false;
    return localStorage.getItem(this.key) ? true : false;
  }
}
